var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.492 4.535l-13.81 6.019a.317.317 0 00.011.576l3.736 2.111a.6.6 0 00.688-.068l7.366-6.35c.049-.041.166-.12.211-.075s-.026.162-.068.211l-6.373 7.178a.6.6 0 00-.06.719l2.442 3.916a.318.318 0 00.572-.008l5.711-13.81a.317.317 0 00-.426-.419z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send.251ba6cbe2d1407af584a24102003bb0.svg";